// extracted by mini-css-extract-plugin
module.exports = {"rss":"_9e1425b4d3--rss--hsWeY"};